import { Radio } from "@mui/material";
import { forwardRef, useImperativeHandle } from "react";

import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import swalDialog from "../../helpers/swalErrorPopup";
import CouponIcon from "../../img/svg/coupon.svg";
import MastercardNew from "../../img/svg/Mastercard_new.svg";
import { isLoadChanger } from "../../store/mainSlice";
import {
  activeMultipleEntryPassesDetailsSelector,
  canBuyNewMultipleEntryPassSelector,
  hasActiveMultipleEntryPassSelector,
} from "../../store/multipleEntryPassSlice";

import userAPI from "../../api/userAPI";
import { isPartnerClalit, isPartnerOvdimBari } from "../../store/partnerStore";

const MultipleEntryPassPaymentLabel = forwardRef(
  ({ last4Digit, selectedPaymentMethod, onPaymentMethodChange, buyNewPass }, ref) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    // Get user data from Redux store
    const mainUserParams = useSelector((state) => state.userSlice.mainUserData);
    const isClalit = useSelector(isPartnerClalit);
    const isOvdimBari = useSelector(isPartnerOvdimBari);

    const multipleEntryPassDetails = useSelector(activeMultipleEntryPassesDetailsSelector);

    const hasActiveMultipleEntryPass = useSelector(hasActiveMultipleEntryPassSelector);

    const canBuyNewMultipleEntryPass = useSelector(canBuyNewMultipleEntryPassSelector);

    const handlePayment = async () => {
      if (hasActiveMultipleEntryPass) return;
      try {
        dispatch(isLoadChanger(true));
        const result = await userAPI.purchaseMultipleEntryPass({
          token: mainUserParams.Token,
          id: mainUserParams.ID,
          phone: mainUserParams.Phone,
          passPlanId: isOvdimBari ? 2 : 1,
        });
        return result;
      } catch (error) {
        swalDialog({ error });
        throw error;
      } finally {
        dispatch(isLoadChanger(false));
      }
    };

    useImperativeHandle(ref, () => ({
      handlePayment,
    }));

    return (
      <>
        {(isClalit || isOvdimBari) &&
          ((hasActiveMultipleEntryPass && multipleEntryPassDetails.NumberOfEntries < 4) ||
            (!hasActiveMultipleEntryPass && canBuyNewMultipleEntryPass)) && (
            <div className="mobile-popup-payment-method-container">
              <div className="mobile-popup-card-number">
                <img src={CouponIcon} alt="Coupon" style={{ width: "28px", height: "28px" }} />
              </div>
              <div className="radio-btn-container">
                <p className={hasActiveMultipleEntryPass ? "credit-passes" : "credit-card"}>
                  {t("MULTIPLE_ENTRY_PASS_DETAILS")}
                  {hasActiveMultipleEntryPass && (
                    <span className="multiple-entry-pass__reminder">
                      {t("MULTIPLE_ENTRY_PASS_REMINDED", {
                        remaining:
                          multipleEntryPassDetails.PossibleNumberOfEntries - multipleEntryPassDetails.NumberOfEntries,
                      })}
                    </span>
                  )}
                </p>
                <Radio
                  checked={selectedPaymentMethod === "multipleEntryPass" || hasActiveMultipleEntryPass}
                  onChange={() => onPaymentMethodChange && onPaymentMethodChange("multipleEntryPass")}
                />
              </div>
            </div>
          )}
        {last4Digit &&
          ((!isClalit && !isOvdimBari) ||
            ((isClalit || isOvdimBari) && !hasActiveMultipleEntryPass) ||
            (hasActiveMultipleEntryPass && multipleEntryPassDetails.NumberOfEntries >= 4)) && (
            <div className="mobile-popup-payment-method-container">
              <div className="mobile-popup-card-number">
                <span className="card-dots">●●●●</span>
                <span className="card-number">{last4Digit}</span>
                <img src={MastercardNew} alt="" className="card-logo" />
              </div>
              <div className="radio-btn-container">
                <p className="credit-card">{t("CREDIT_CARD")}</p>
                <Radio
                  checked={selectedPaymentMethod === "creditCard"}
                  onChange={() => onPaymentMethodChange && onPaymentMethodChange("creditCard")}
                />
              </div>
            </div>
          )}
      </>
    );
  },
);

export default MultipleEntryPassPaymentLabel;
